import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/axiosInstance"; // Import axiosInstance
import Cookies from "js-cookie";
import axios from "axios";


export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/auth/send-otp", payload); // Use axiosInstance
      return response.data; // Response should include the token
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/auth/verify-otp", payload);
      return response.data; // Response should include success message or user data
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);



// Async thunk for login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/auth/login", payload); // Use axiosInstance
      return response.data; // Response should include the token
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/api/auth/register", payload); // Use axiosInstance
      return response.data; // Response should include a success message or token
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchStateDetails = createAsyncThunk(
  "auth/fetchStateDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${payload}`);
      return response.data; // Response should include a success message or token
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState: {
    otp: "",
    data: {},
    registerData: {},
    // user: null,
    token: null,
    loading: false,
    error: null,
    stateDetails:{},
  },
  reducers: {
    logout: (state) => {
      // state.user = null;
      state.token = null;
      Cookies.remove("token"); // Clear token on logout
    },
  },
  extraReducers: (builder) => {
    builder

    // Send OTP
      .addCase(sendOtp.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.otp = "";
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.otp = action.payload;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

        .addCase(verifyOtp.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(verifyOtp.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload.data; // Save user data after successful verification
      
          if (!action.payload.data.registrationRequired) {
              state.token = action.payload.data.token;
              Cookies.set("token", action.payload.data.token);
          } else {
              // Ensure no token is stored if user needs to register
              state.token = null;
              Cookies.remove("token");
          }
      })
      
        .addCase(verifyOtp.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })


      // Login User
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = {};
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        // state.user = action.payload.user;
        state.token = action.payload.data.token;
        Cookies.set("token", action.payload.data.token);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = action.payload;
      })

      // Register User
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.registerData = {};
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.registerData = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.registerData = action.payload;
      })

      // Fetch State Details Using POstal Code
      .addCase(fetchStateDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.stateDetails = action.payload;
      })
      .addCase(fetchStateDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
